import { scrollIntoView } from './scrollIntoView.js';

const cartIcon = document.querySelector('.js-header-cart-icon');
const cartIconCount = document.querySelector('[data-js-selector="cart-count"]');


document.addEventListener('cart:updated', () => {
  const cartIsVisible = isElementInViewport(cartIcon);

  if (cartIsVisible) {
    animateCartIcons();
  } else {
    scrollIntoView('#header');
    setTimeout(() => {
      animateCartIcons();
    }, 500);
  }
});

cartIcon.addEventListener('animationend', () => {
  removeAnimation();
});

const animateCartIcons = () => {
  cartIcon.classList.add('header__item-cart-shake');
  cartIconCount?.classList.add('header__item-count-shake');
}

const removeAnimation = () => {
  cartIcon.classList.remove('header__item-cart-shake');
  cartIconCount?.classList.remove('header__item-count-shake');
}

const isElementInViewport = (el) => {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
